import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function BootcampWaitlist() {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const r = await fetch(`${BACKEND}/api/bootcamp/waitlist`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim(), first_name: firstName.trim(), source: 'bootcamp_email_6' }),
      });
      if (r.ok) {
        setDone(true);
      } else {
        const body = await r.json().catch(() => ({}));
        setErr(body.detail || 'Something went wrong. Please try again.');
      }
    } catch {
      setErr('Network error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0B1E3F] via-[#0a1c3a] to-[#0B1E3F] flex items-center justify-center px-4 py-12" data-testid="bootcamp-waitlist-page">
      <div className="max-w-[560px] w-full bg-white rounded-2xl shadow-2xl p-8 sm:p-10">
        {done ? (
          <div className="text-center" data-testid="bootcamp-waitlist-success">
            <div className="w-14 h-14 mx-auto rounded-full bg-[#0B1E3F] flex items-center justify-center mb-4">
              <CheckCircle2 className="h-7 w-7 text-[#D4A434]" />
            </div>
            <h1 className="font-heading text-[1.8rem] font-bold text-[#0B1E3F] mb-3">You’re on the list.</h1>
            <p className="text-[#3a3a3a] mb-6">
              When the next Pre-Season Mindset Bootcamp cohort opens, you’ll be the first to hear —
              early-bird spots first.
            </p>
            <Link to="/" className="text-[14px] text-[#0B1E3F] underline" data-testid="bootcamp-home-link">
              ← Back to apexathleticmind.com
            </Link>
          </div>
        ) : (
          <>
            <div className="font-mono-accent uppercase tracking-[0.25em] text-[10px] text-[#D4A434] font-bold mb-3">
              Pre-Season Mindset Bootcamp
            </div>
            <h1 className="font-heading text-[1.9rem] sm:text-[2.1rem] font-bold tracking-tight text-[#0B1E3F] mb-3">
              Get on the waitlist.
            </h1>
            <p className="text-[15px] text-[#3a3a3a] leading-relaxed mb-6">
              4-week virtual cohort. 6 frameworks. Live group sessions with Coach Lewis,
              1:1 check-in, and the Apex AI app. Capped at 15 athletes per cohort.
            </p>
            <form onSubmit={submit} className="space-y-3">
              <Input
                placeholder="First name"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
                data-testid="bootcamp-firstname-input"
              />
              <Input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="bootcamp-email-input"
              />
              {err && (
                <p className="text-[13px] text-red-600" data-testid="bootcamp-error">{err}</p>
              )}
              <Button
                type="submit"
                disabled={loading || !email || !firstName}
                className="w-full bg-[#0B1E3F] hover:bg-[#091735] text-white font-bold h-12"
                data-testid="bootcamp-submit-button"
              >
                <Sparkles className="mr-2 h-4 w-4" />
                {loading ? 'Joining…' : 'Join the waitlist'}
              </Button>
            </form>
            <p className="text-[12px] text-[#666] mt-4 text-center">
              No spam. You’ll only hear from us when the next cohort opens.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
